import * as React from 'react';
import { useState } from 'react';
import { toKebabCaseWithAccentsCyrillicCJK } from 'corporate-utils';

import MenuItemNested from '../menu-item-nested/MenuItemNested';
import MenuItemSingle from '../menu-item-single/MenuItemSingle';
import MobileMenu from '../mobile-menu/MobileMenu';
import { getAvailableStringFromCategoryByLocale } from '../../../utils/categories';

import {
  CloseStyled,
  HamburgerMenuBodyContainer,
  HamburgerMenuContainer,
  HamburgerMenuHeader,
  ModileMenuContainerStyled,
} from './MobileMenuModal.style';
import { Link } from '../../../models/auto-generated-strapi-types/types/components/Link';
import { LinkSublink } from '../../../models/auto-generated-strapi-types/types/components/LinkSublink';

const MenuMobileModal = ({
  mainLinks,
  megamenuLinks,
  translations,
  setOpen,
  open,
  locale,
}: {
  mainLinks: any;
  megamenuLinks: any;
  translations: any;
  setOpen: any;
  open: boolean;
  locale: string;
}) => {
  const [openLocal, setOpenLocal] = useState(true);

  const prepareCatalogues = (megamenuLinks: any): any => {
    return (
      <MenuItemNested
        link={{ text: translations.mobileMenu.catalog, url: '' }}
        key={'menuitemnested_father'}
        level={1}
        onClick={() => setOpenLocal(false)}
        open={openLocal}
        useOpenLocal={true}
      >
        {megamenuLinks?.map((megamenuLink: any, index: number) => {
          return (
            <MenuItemNested
              key={`menuitemnested_${index}`}
              link={{ text: megamenuLink.text, url: '' }}
              level={2}
              open={openLocal}
            >
              {megamenuLink.firstChild
                ?.filter?.((category: any) => category?.depth !== 0)
                ?.map((link: any, indexInternal: number) => {
                  const father = megamenuLink.firstChild.find?.(
                    (category: any) => category?.depth === 0
                  );

                  const url = `${toKebabCaseWithAccentsCyrillicCJK(
                    father &&
                      getAvailableStringFromCategoryByLocale(
                        father,
                        locale,
                        'packages/corporate-ui/src/components/mobile-menu/mobile-menu-modal/MobileMenuModal.tsx'
                      )
                  )}/${toKebabCaseWithAccentsCyrillicCJK(
                    link &&
                      getAvailableStringFromCategoryByLocale(
                        link,
                        locale,
                        'packages/corporate-ui/src/components/mobile-menu/mobile-menu-modal/MobileMenuModal.tsx'
                      )
                  )}`;

                  return (
                    <MenuItemSingle
                      level={3}
                      open={openLocal}
                      key={`menuitemsingle_${
                        indexInternal * index + (index + indexInternal)
                      }`}
                      link={{
                        id: link,
                        text:
                          link &&
                          getAvailableStringFromCategoryByLocale(
                            link,
                            locale,
                            'packages/corporate-ui/src/components/mobile-menu/mobile-menu-modal/MobileMenuModal.tsx'
                          ),
                        url,
                        subLink: [],
                      }}
                      onClick={() => {
                        setOpen(false);
                      }}
                    ></MenuItemSingle>
                  );
                })}
            </MenuItemNested>
          );
        })}
      </MenuItemNested>
    );
  };

  const prepareMainLink = (link: Link): any => {
    return (
      <MenuItemNested
        link={{ text: link.text, url: link?.url || '' }}
        key={'menuitemnested_father'}
        level={1}
        onClick={() => setOpenLocal(false)}
        open={openLocal}
        useOpenLocal={false}
      >
        {link?.subLink?.map((subLink: LinkSublink, index: number) => {
          return (
            <MenuItemSingle
              level={2}
              open={openLocal}
              key={`menuitemsingle_${index + index}`}
              link={{
                id: index,
                text: subLink.text,
                url: subLink.url,
                subLink: [],
              }}
              onClick={() => {
                setOpen(false);
              }}
            ></MenuItemSingle>
          );
        })}
      </MenuItemNested>
    );
  };

  const list = [];

  if (megamenuLinks.length > 0) list.push(prepareCatalogues(megamenuLinks));

  list.push(
    ...mainLinks?.map((link: Link, index: number) => {
      return link?.subLink?.length === 0 ? (
        <MenuItemSingle
          level={1}
          link={link}
          key={`menuitems_${index}`}
          onClick={() => {
            setOpen(false);
          }}
        ></MenuItemSingle>
      ) : (
        prepareMainLink(link)
      );
    })
  );

  return (
    <HamburgerMenuContainer open={open}>
      <HamburgerMenuBodyContainer>
        <HamburgerMenuHeader>
          <CloseStyled
            onClick={() => {
              setOpen(false);
            }}
          />
        </HamburgerMenuHeader>

        <ModileMenuContainerStyled>
          <MobileMenu>{list}</MobileMenu>
        </ModileMenuContainerStyled>
      </HamburgerMenuBodyContainer>
    </HamburgerMenuContainer>
  );
};

export default MenuMobileModal;

export { MenuItemSingle, MenuItemNested };
